module.exports = __webpack_public_path__ + "img/energia.464a20db.png";